/**
 * HomeView - Landing page / Home view
 *
 * Simple landing page matching original design
 */

import { BaseView } from './BaseView';

export class HomeView extends BaseView {
	/**
	 * Render the home view content
	 */
	render(): string {
		return `
			<div class="content">
				<h1>Z&P Zapital IQ</h1>
				<p>Welcome to Zapital IQ</p>
				<div class="demo-links">
					<h2>Available Demo Pages:</h2>
					<ul>
						<li><a href="/profile">NVIDIA Corporation Profile</a></li>
					</ul>
				</div>
			</div>
		`;
	}

	/**
	 * Lifecycle hook - hide sidebar on home page
	 */
	protected onMount(): void {
		// Hide sidebar on home page
		const sidebar = document.querySelector('.sidebar');
		if (sidebar) {
			(sidebar as HTMLElement).style.display = 'none';
		}

		// Expand main content to full width
		const contentContainer = document.querySelector('.content-container');
		if (contentContainer) {
			(contentContainer as HTMLElement).style.gridTemplateColumns = '1fr';
		}
	}

	/**
	 * Lifecycle hook - restore sidebar when leaving
	 */
	protected onUnmount(): void {
		// Restore sidebar visibility
		const sidebar = document.querySelector('.sidebar');
		if (sidebar) {
			(sidebar as HTMLElement).style.display = '';
		}

		// Restore grid layout
		const contentContainer = document.querySelector('.content-container');
		if (contentContainer) {
			(contentContainer as HTMLElement).style.gridTemplateColumns = '';
		}
	}
}
